import { useState } from "react";
import emailjs from "emailjs-com";
import { iconMap } from "../utils/iconMap";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);

    emailjs
      .sendForm(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        e.target,
        "YOUR_PUBLIC_KEY"
      )
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  // Ícones
  const MapIcon = iconMap.map;
  const PhoneIcon = iconMap.phone;
  const EmailIcon = iconMap.email;
  const InstagramIcon = iconMap.instagram;
  const WhatsappIcon = iconMap.whatsapp;

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="row justify-content-center">
            {/* Formulário permanece comentado (sem alteração) */}
          </div>
        </div>

        <div className="col-12 col-md-10 offset-md-1 contact-info text-center">
          <div className="contact-item">
            <h3>Informações de Contato</h3>
            <p>
              <a
                href="https://maps.app.goo.gl/XDo4M1HMHh5bQ8g66"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <span className="contact-icon">
                  <MapIcon size={18} /> Endereço
                </span>{" "}
                {props.data ? props.data.address : "loading"}
              </a>
            </p>
          </div>

          <div className="contact-item">
            <p>
              <a
                href={`tel:${props.data ? props.data.phone : ""}`}
                className="phone-link"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <span className="contact-icon">
                  <PhoneIcon size={18} /> Telefone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </a>
            </p>
          </div>

          <div className="contact-item">
            <p>
              <a
                href={`mailto:${props.data ? props.data.email : ""}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <span className="contact-icon">
                  <EmailIcon size={18} /> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </a>
            </p>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <div className="social">
              <ul className="d-flex justify-content-center align-items-center p-0 m-0">
                <li>
                  <a
                    href={props.data ? props.data.instagram : "/"}
                    aria-label="Instagram"
                  >
                    <InstagramIcon size={22} />
                  </a>
                </li>

                <li>
                  <a
                    href={props.data ? props.data.whatsapp : "/"}
                    aria-label="WhatsApp"
                  >
                    <WhatsappIcon size={22} />
                  </a>
                </li>

                {/* <li>
                <a href={props.data ? props.data.youtube : "/"}>
                <i className="fa fa-youtube"></i>
              </a>
              </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
